<template>
  <div class="modal-backdrop">
    <div class="modal-container">
      <div class="modal-header">
        <h3 class="modal-title">Course URL Details</h3>
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>
      <div class="modal-body" v-if="course">
        <div class="details-container">
          <div class="detail-row">
            <div class="detail-label">ID:</div>
            <div class="detail-value">{{ course.id }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Course ID:</div>
            <div class="detail-value">{{ course.course_id }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Course Name:</div>
            <div class="detail-value">{{ course.course_name || 'N/A' }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Image URL:</div>
            <div class="detail-value url-value">
              <div class="url-container">
                <a :href="course.image_url" target="_blank" class="url-link">{{ course.image_url }}</a>
              </div>
              <button 
                v-if="course.image_url" 
                class="preview-btn" 
                @click="$emit('preview', course.image_url, 'image')"
              >
                <i class="fas fa-eye"></i> Preview
              </button>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Image URL (Arabic):</div>
            <div class="detail-value url-value">
              <div class="url-container">
                <a :href="course.image_url_ar" target="_blank" class="url-link">{{ course.image_url_ar }}</a>
              </div>
              <button 
                v-if="course.image_url_ar" 
                class="preview-btn" 
                @click="$emit('preview', course.image_url_ar, 'image')"
              >
                <i class="fas fa-eye"></i> Preview
              </button>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Downloadable URL:</div>
            <div class="detail-value url-value">
              <div class="url-container">
                <a :href="course.downloadable_url" target="_blank" class="url-link">{{ course.downloadable_url || 'N/A' }}</a>
              </div>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Preview URL:</div>
            <div class="detail-value url-value">
              <div class="url-container">
                <a :href="course.preview_url" target="_blank" class="url-link">{{ course.preview_url || 'N/A' }}</a>
              </div>
              <button 
                v-if="course.preview_url" 
                class="preview-btn video-btn" 
                @click="$emit('preview', course.preview_url, 'video')"
              >
                <i class="fas fa-play"></i> Play Video
              </button>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Preview Thumbnail:</div>
            <div class="detail-value url-value">
              <div class="url-container">
                <a :href="course.preview_thumbnail_url" target="_blank" class="url-link">{{ course.preview_thumbnail_url || 'N/A' }}</a>
              </div>
              <button 
                v-if="course.preview_thumbnail_url" 
                class="preview-btn" 
                @click="$emit('preview', course.preview_thumbnail_url, 'image')"
              >
                <i class="fas fa-eye"></i> Preview
              </button>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Created At:</div>
            <div class="detail-value">{{ formatDate(course.created_at) }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">Updated At:</div>
            <div class="detail-value">{{ formatDate(course.updated_at) }}</div>
          </div>
        </div>
        <div class="modal-actions">
          <button class="btn btn-secondary" @click="$emit('close')">Close</button>
          <button class="btn btn-primary" @click="$emit('edit', course)">
            <i class="fas fa-edit"></i> Edit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsModal',
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'edit', 'preview'],
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

.modal-container {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 40rem;
  max-height: 90vh;
  animation: slideIn 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #343a40;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
}

.details-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 1rem;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  width: 35%;
  font-weight: 600;
  color: #495057;
}

.detail-value {
  width: 65%;
  word-break: break-word;
}

.url-value {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.url-container {
  overflow: hidden;
  text-overflow: ellipsis;
}

.url-link {
  color: #3498db;
  text-decoration: none;
  font-size: 0.875rem;
}

.url-link:hover {
  text-decoration: underline;
}

.preview-btn {
  align-self: flex-start;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  transition: all 0.2s ease;
}

.preview-btn:hover {
  background-color: #e9ecef;
}

.video-btn {
  background-color: #e3f2fd;
  border-color: #bbdefb;
  color: #0d47a1;
}

.video-btn:hover {
  background-color: #bbdefb;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e9ecef;
}

.btn {
  padding: 0.75rem 1.25rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-secondary {
  background-color: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
}

.btn-secondary:hover {
  background-color: #e9ecef;
}

.btn-primary {
  background-color: #3498db;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #2980b9;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .detail-row {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .detail-label,
  .detail-value {
    width: 100%;
  }
  
  .modal-actions {
    flex-direction: column-reverse;
  }
  
  .btn {
    width: 100%;
    justify-content: center;
  }
}
</style> 